import React from 'react';
import vivus from 'vivus';
import ReactFullpage from '@fullpage/react-fullpage';

import { Link } from 'react-router-dom';

import {HeaderContainer} from './HeaderContainer';

const anchors = ["Home", "Image-editor", "Loops", "Screenshot-editor", "Telegram", "My-travels", "Ringcentral", "Revon"];
const tooltips = ["Home", "Telegram image editor", "Loops", "Screenshot editor", "Telegram charts", "My-travels", "Ringcentral", "Revon"];

export class ProjectsContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      slide: 0,
    }

  }

   componentDidMount(){
    this.logo = new vivus('svg-logo', {type: 'sync', duration: 200})
  }

  onScroll = (slide) => {
    this.setState({slide}, () => {
      if(!this.logo) return

      if (!slide)
        this.logo.play()
      else
        this.logo.stop().reset()
    })
  }

  render() {
    const { slide } = this.state

    return (
      <div>
        <HeaderContainer show={!!slide}/>

        <ReactFullpage
          anchors={anchors}
          navigation
          navigationTooltips={tooltips}
          afterLoad={(origin, destination, direction)=>{
            this.onScroll(destination.index)
          }}
          render={({fullpageApi}) => {
            return (
              <ReactFullpage.Wrapper>
                <div className="section">
                  <div className="projects-slide-logo">
                    <svg id="svg-logo" viewBox="0 0 760 800" width="90%" height="85%">

                      <path d="M 320 350 L 320 55" fill="transparent" stroke="#ee3454" strokeWidth="2" />
                      <path d="M 320 350 L 300 350" fill="transparent" stroke="#ee3454" strokeWidth="2" />

                      <path d="M 320 450 L 320 745" fill="transparent" stroke="#ee3454" strokeWidth="2" />
                      <path d="M 320 450 L 300 450" fill="transparent" stroke="#ee3454" strokeWidth="2" />

                      <path d="M 0 200 L 0 100" fill="transparent" stroke="#ee3454" strokeWidth="2" />
                      <path d="M 0 600 L 0 700" fill="transparent" stroke="#ee3454" strokeWidth="2" />

                      <path d="M 0 600 A 200 200 0 1 0 0 200" fill="transparent" stroke="#ee3454" strokeWidth="2" />

                      <path d="M 0 100 A 300 300 0 0 1 300 350" fill="transparent" stroke="#ee3454" strokeWidth="2" />
                      <path d="M 0 700 A 300 300 0 0 0 300 450" fill="transparent" stroke="#ee3454" strokeWidth="2" />

                      <path d="M 420 450 L 500 450" fill="transparent" stroke="#ee3454" strokeWidth="2" />
                      <path d="M 420 350 L 500 350" fill="transparent" stroke="#ee3454" strokeWidth="2" />

                      <path d="M 420 350 L 420 150" fill="transparent" stroke="#ee3454" strokeWidth="2" />
                      <path d="M 420 450 L 420 650" fill="transparent" stroke="#ee3454" strokeWidth="2" />

                      <path d="M 420 650 A 1100 1100 0 0 1 580 677" fill="transparent" stroke="#ee3454" strokeWidth="2" />
                      <path d="M 320 745 A 1000 1000 0 0 1 612 788" fill="transparent" stroke="#ee3454" strokeWidth="2" />

                      <path d="M 500 450 A 300 300 0 0 0 580 609" fill="transparent" stroke="#ee3454" strokeWidth="2" />
                      <path d="M 500 350 A 300 300 0 0 1 580 191" fill="transparent" stroke="#ee3454" strokeWidth="2" />

                      <path d="M 690 570 L 760 640" fill="transparent" stroke="#ee3454" strokeWidth="2" />
                      <path d="M 612 788 L 760 640" fill="transparent" stroke="#ee3454" strokeWidth="2" />
                      <path d="M 580 677 L 690 570" fill="transparent" stroke="#ee3454" strokeWidth="2" />

                      <path d="M 580 609 L 650 537" fill="transparent" stroke="#ee3454" strokeWidth="2" />
                      <path d="M 580 191 L 650 263" fill="transparent" stroke="#ee3454" strokeWidth="2" />
                      <path d="M 650 263 A 200 200 0 0 0 650 537" fill="transparent" stroke="#ee3454" strokeWidth="2" />

                      <path d="M 580 123 L 690 230" fill="transparent" stroke="#ee3454" strokeWidth="2" />
                      <path d="M 612 12 L 760 160" fill="transparent" stroke="#ee3454" strokeWidth="2" />
                      <path d="M 690 230 L 760 160" fill="transparent" stroke="#ee3454" strokeWidth="2" />

                      <path d="M 420 150 A 1100 1100 0 0 0 580 123" fill="transparent" stroke="#ee3454" strokeWidth="2" />
                      <path d="M 320 55 A 1000 1000 0 0 0 612 12" fill="transparent" stroke="#ee3454" strokeWidth="2" />

                      <path d="M 0 200
                      L 0 100
                      A 300 300 0 0 1 300 350
                      L 320 350
                      L 320 55
                      A 1000 1000 0 0 0 612 12
                      L 760 160
                      L 690 230
                      L 580 123
                      A 1100 1100 0 0 1 420 150
                      L 420 350
                      L 500 350
                      A 300 300 0 0 1 580 191
                      L 650 263
                      A 200 200 0 0 0 650 537
                      L 580 609
                      A 300 300 0 0 1 500 450
                      L 420 450
                      L 420 650
                      A 1100 1100 0 0 1 580 677
                      L 690 570
                      L 760 640
                      L 612 788
                      A 1000 1000 0 0 0 320 745
                      L 320 450
                      L 300 450
                      A 300 300 0 0 1 0 700
                      L 0 600
                      A 200 200 0 1 0 0 200
                      Z" fill="#d02240" stroke="#d02240" id="logo-shadow" transform="translate(5,5)" className={!slide ? 'active' : ''} strokeWidth="1"/>

                      <path d="M 0 200
                      L 0 100
                      A 300 300 0 0 1 300 350
                      L 320 350
                      L 320 55
                      A 1000 1000 0 0 0 612 12
                      L 760 160
                      L 690 230
                      L 580 123
                      A 1100 1100 0 0 1 420 150
                      L 420 350
                      L 500 350
                      A 300 300 0 0 1 580 191
                      L 650 263
                      A 200 200 0 0 0 650 537
                      L 580 609
                      A 300 300 0 0 1 500 450
                      L 420 450
                      L 420 650
                      A 1100 1100 0 0 1 580 677
                      L 690 570
                      L 760 640
                      L 612 788
                      A 1000 1000 0 0 0 320 745
                      L 320 450
                      L 300 450
                      A 300 300 0 0 1 0 700
                      L 0 600
                      A 200 200 0 1 0 0 200
                      Z" fill="#ee3454" stroke="#ee3454" id="logo" className={!slide ? 'active' : ''} strokeWidth="1"/>
                    </svg>
                    <div className="projects-slide-logo-btns">
                      <a className={!slide ? 'active' : ''} onClick={() => fullpageApi.moveSectionDown()}>Projects</a>
                      <Link className={!slide ? 'active' : ''} to="/cv">CV</Link>
                    </div>
                  </div>
                </div>

                <div className="section">
                  <div className="projects-slide-site telegram-image-editor">
                    <div className="projects-slide-site-info">
                      <div className="projects-slide-site-info-title">Image Editor for Telegram web application</div>
                      <div className="projects-slide-site-info-description">
                        <p>It is a project for Telegram Contest (<span>result:</span> 4th place).</p>
                        <p>The image editor includes cropper with several formats, various image filters, text, stickers and brush layers. Each layer can be added on image, changed, moved, rotated and deleted.</p>
                        <p><span>Using technologies:</span> JavaScript, Canvas.</p>
                      </div>
                      <div className="projects-slide-site-info-btns">
                        <a target="_blank" rel="noopener noreferrer" href="https://entry5501-js2024r2.usercontent.dev/">View demo</a>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="section">
                  <div className="projects-slide-site loops">
                    <div className="loops-iphones">
                      <div className="loops-iphone video">
                        <img className="loops-iphone-mock" alt="game loops" src="./images/iphone.png"/>
                        <video loop="true" muted="true" autoPlay="autoplay" className="loops-video">
                          <source type="video/mp4" src="./images/loops_video.mp4"></source>
                        </video>
                      </div>

                      <div className="loops-iphone image">
                        <img className="loops-iphone-mock" alt="game loops" src="./images/iphone.png"/>
                        <img className="loops-iphone-screen" alt="game loops screen" src="./images/loops_1.png"/>
                      </div>
                    </div>

                    <div className="projects-slide-site-info">
                      <div className="projects-slide-site-info-title">Game "Loops"</div>
                      <div className="projects-slide-site-info-description">
                        <p>Modern 2D game "Loops" for web and iOS platforms.
                        Game has settings: saving of progress, multiple themes, settings of sound and vibration.</p>
                        <p><span>Using technologies:</span> React.Native, Javascript.</p>
                      </div>
                      <div className="projects-slide-site-info-btns">
                        <a rel="noopener noreferrer" target="_blank" href="./loops">Play</a>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="section">
                  <div className="projects-slide-site screenshot-editor">
                    <div className="projects-slide-site-info">
                      <div className="projects-slide-site-info-title">Screenshot Editor</div>
                      <div className="projects-slide-site-info-description">
                        <p>Javascript engine for drawing, resizing and moving items (rectangles, lines, arrows, text), selection of main area, cropping and creation of web page screenshots.</p>
                        <p><span>Using technologies:</span> JavaScript, Canvas.</p>
                        <p><span>Company:</span> goTrg.com.</p>
                      </div>
                      <div className="projects-slide-site-info-btns">
                        <Link to="/editor">View demo</Link>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="section">
                  <div className="projects-slide-site chart">
                    <div className="projects-slide-site-info">
                      <div className="projects-slide-site-info-title">Javascript library for Telegram</div>
                      <div className="projects-slide-site-info-description">
                        <p>Javascript library for Telegram Contest. Charts has smart timeline navigation and 2 themes (dark, light). Size ~ 10.7 KB (3.8 KB via gzip).</p>
                        <p><span>Using technologies:</span> Javascript.</p>
                      </div>
                      <div className="projects-slide-site-info-btns">
                        <a target="_blank" rel="noopener noreferrer" href="./chart">View demo</a>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="section">
                  <div className="projects-slide-site my-travels">
                    <div className="projects-slide-site-info">
                      <div className="projects-slide-site-info-title">Social network My-travels.net</div>
                      <div className="projects-slide-site-info-description">
                        <p>Social network for travelers with personal travel map, travel history and infographics, search for fellow travelers and the rating of travelers.</p>
                        <p><span>Using technologies:</span> Angular, Jade, CoffeeScript, Less, Bower, Gulp, Amcharts, PHP, MySQL.</p>
                      </div>
                      <div className="projects-slide-site-info-btns">
                        <a target="_blank" rel="noopener noreferrer" href="https://my-travels.net">Visit site</a>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="section">
                  <div className="projects-slide-site roadmap">
                    <div className="projects-slide-site-info">
                      <div className="projects-slide-site-info-title">Сorporate system in Ringcentral.com</div>
                      <div className="projects-slide-site-info-description">
                        <p>The corporate web system for project managers and a deployment team with collaborations with API and webhooks of Jira, Confluence and other systems.</p>
                        <p><span>Using technologies:</span> JavaScript, React, Redux, Angular, Sass, Webpack, Node.js, MongoDB, WebSockets, Jest, Mocha, Chai, Enzyme, Nginx, Cron, RabbitMQ.</p>
                        <p><span>Company:</span> Ringcentral.com.</p>
                      </div>
                      <div className="projects-slide-site-info-btns">
                        <Link to="/cv">More details</Link>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="section">
                  <div className="projects-slide-site revon">
                    <div className="projects-slide-site-info">
                      <div className="projects-slide-site-info-title">Web-client applications for doctors and patients in Revon.ai</div>
                      <div className="projects-slide-site-info-description">
                        <p>Web client applications for doctors and patients with a lot of graphs and infographics.</p>
                        <p><span>Using technologies:</span> JavaScript, Angular, Jade, Less, Gulp, Bower, Highcharts, Sketch.</p>
                        <p><span>Company:</span> Cuberto.</p>
                      </div>
                      <div className="projects-slide-site-info-btns">
                        <a target="_blank" rel="noopener noreferrer" href="./graph">View demo</a>
                      </div>
                    </div>
                  </div>
                </div>

              </ReactFullpage.Wrapper>
            );
          }}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ProjectsContainer.js